import * as ACTION_TYPES from '../actions/action_types'

const initialState = {
    stateprops1: false,
    spinner: false,
    image_upload_error: false,
    data_fetch: false,
}

const Reducer1 = (state = initialState, action) => {
    switch(action.type) {
        case ACTION_TYPES.ACTIONONE_SUCCESS:
            return {
                ...state,
                stateprops1: true,
            }
        case ACTION_TYPES.SPINNER:
            return {
                ...state,
                spinner: action.payload,
            }
        case ACTION_TYPES.IMAGE_UPLOAD_ERROR:
            return {
                ...state,
                image_upload_error: action.payload,
            }
        case ACTION_TYPES.DATA_FETCH:
            return {
                ...state,
                data_fetch: action.payload
            }
        default:
            return state
    }
}

export default Reducer1;